// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:27
import { ListEmailPDFMailling_abstract } from './../../abstract/SagaSchema/ListObjects/ListEmailPDFMailling_abstract';
export class ListEmailPDFMailling extends ListEmailPDFMailling_abstract {}
